import { useAccountDataQuery } from 'queries/account';

export enum AddonFeature {
  User = 1,
  Partners = 21,
  Rbac = 22,
  TimeTrackingUsers = 38,
  SupportCosts = 39,
  LiteUsers = 27,
  CustomReport = 40,
  SkillMatrix = 41, // @aman TODO: Update addon value
  ResourceRequest = 42, // @logesh TODO: Update addon value
}

const nonRbacAddonAccountIds = [
  12059, // this is the account id for uniqus
  400, // this is the account id for growth molecules
];

export const useAddon = (addonFeature: AddonFeature): boolean => {
  const { data: accountData } = useAccountDataQuery();

  const isTheAddonPresent =
    Boolean(
      accountData?.billingMeta?.subscription?.addons?.find(
        (addon) => addon?.addonId === addonFeature,
      ),
    ) ?? false;

  if (addonFeature === AddonFeature.Rbac) {
    return (
      isTheAddonPresent ||
      nonRbacAddonAccountIds.includes(accountData?.account?.accountId ?? -1)
    );
  }

  return isTheAddonPresent;
};
